import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    padding: theme.spacing(3),
    flexDirection: 'column',
    [theme.breakpoints.only('sm')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.only('xs')]: {
      padding: theme.spacing(1),
    },
  },
  container: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  productWrapper: {
    flex: 1,
    padding: theme.spacing(1),
  },
  summary: {
    width: '35%',
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
  },
  txNumber: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
  },
  wrapper: {
    display: 'flex',
    width: '100%',
    marginBottom: theme.spacing(3),
  },
  customerWrapper: {
    flex: 1,
  },
  primaryText: {
    fontSize: 14,
    color: '#777777',
  },
  secondaryText: {
    fontSize: 20,
    color: 'black',
    marginBottom: theme.spacing(2),
    textTransform: 'capitalize',
  },
  imgWrapper: {
    height: 200,
    width: 200,
    objectFit: 'contain',
    borderRadius: 5,
    border: 'solid 0.5px #CCCCCC',
    margin: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EEEEEE',
  },
  image: {
    height: 180,
    width: 180,
    borderRadius: 5,
  },
  detailWrapper: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  meta: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    margin: theme.spacing(1),
    position: 'relative',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  productName: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  productPrice: {
    fontWeight: 'bold',
    fontSize: 20,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  txQuantity: {
    color: '#777777',
    fontSize: 14,
    marginBottom: theme.spacing(1),
  },
  txRefund: {
    color: theme.palette.error,
    fontSize: 14,
    marginBottom: theme.spacing(1),
  },
  amountWrapper: {
    color: '#777777',
    fontSize: 16,
    position: 'absolute',
    right: 0,
    bottom: 0,
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
    },
  },
  highlightPrice: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    fontSize: 20,
  },
  floatingDiv: {
    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    borderRadius: '4px',
    padding: '8px',
  },
  tablePayment: {
    '& .MuiTableCell-sizeSmall': {
      padding: '6px',
      borderBottom: 'none',
      color: '#777',
    },
    '& .MuiTableCell-sizeSmall:first-child': {
      paddingLeft: '0',
      fontWeight: 'bold',
    },
    '& .MuiTableCell-sizeSmall:last-child': {
      paddingRight: '0',
      textTransform: 'capitalize',
    },
  },
}))

export default useStyles
